import { render, staticRenderFns } from "./Titles.vue?vue&type=template&id=4b42066c&scoped=true"
import script from "./Titles.vue?vue&type=script&lang=js"
export * from "./Titles.vue?vue&type=script&lang=js"
import style0 from "./Titles.vue?vue&type=style&index=0&id=4b42066c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b42066c",
  null
  
)

export default component.exports